import { z } from 'zod';
import { I18nStringSchema } from '../../core/i18n';
import { BaseEffectSchema } from '../effect';
import { ImageAssetSchema } from '../ui/imageAsset';
import { ResourceSchema } from './resource';
import { TipSchema } from './tip';
export const BaseEffectReferenceSchema = BaseEffectSchema.extend({
    longDescriptionI18n: I18nStringSchema,
    hero: ImageAssetSchema.optional(),
    tips: z.array(TipSchema),
    resources: z.array(ResourceSchema)
});
//# sourceMappingURL=effect.js.map